import { useQuery } from "react-query";
import API from "@Config/axios";
import { QUERY_KEY } from "@Constants/query-keys";

// Fungsi yang memanggil endpoint ke server
const fetchDisplayQueue = async () => {
  const { data } = await API.get("/queues/getDisplayQueue");
  return data;
};

// Custom hook yang bisa dipakai di komponen manapun
// options = { refetchInterval: 10000 } → auto-refresh tiap 10 detik
const useGetDisplayQueue = (options = {}) => {
  return useQuery([QUERY_KEY.GET_DISPLAY_QUEUE], fetchDisplayQueue, options);
};

export default useGetDisplayQueue;
